import React, { createContext, useContext, useState, useEffect } from 'react';
import adminApi from '../services/adminApi';

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if already logged in
    const storedAdmin = adminApi.getAdminUser();
    if (storedAdmin && adminApi.isAuthenticated()) {
      setAdmin(storedAdmin);
    }
    setIsLoading(false);
  }, []);

  const login = async (email, password) => {
    const data = await adminApi.login(email, password);
    setAdmin(data.admin);
    return data;
  };

  const logout = () => {
    adminApi.logout();
    setAdmin(null);
  };

  const value = {
    admin,
    isLoading,
    isAuthenticated: !!admin,
    login,
    logout,
  };

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used within an AdminAuthProvider');
  }
  return context;
}
